/**
 * @module FE-CU58_利用規約_プライバシーポリシー同意画面
 */
import Header from '../../components/header/Header.vue';
import PcPageTitle from '../../components/pcPageTitle/PcPageTitle.vue';
import BreadCrumbList from '../../components/breadCrumb/List.vue';
import PCFooter from '@/components/footer/PCFooter.vue';

const PAGE_ID = 'FE-CU58';

export default {
  name: 'ApprovalTerms',
  components: {
    Header,
    PcPageTitle,
    BreadCrumbList,
    PCFooter,
  },
  data(vm) {
    return {
      title: vm.$vuetify.lang.t(
        '$vuetify.FECU58利用規約プライバシーポリシー同意画面.利用規約プライバシーポリシー'
      ), // "利用規約/プライバシーポリシー",
      hintText: vm.$vuetify.lang.t(
        '$vuetify.メッセージ一覧.FECU58利用規約プライバシーポリシー同意画面.C0001'
      ), //"本サービスの利用規約/プライバシーポリシーをご確認いただき、同意可能であれば、「同意します」を選択してください。",
      serviceCheck: false,
      privacyPolicyCheck: false,
      termsDialog: false,
      termsMessage: '',
      isTermsDisabled: true,
      privacyPolicyDialog: false,
      privacyPolicyMessage: '',
      isPrivacyPolicyDisabled: true,
      fromOneTimeUrl: false,
      urlRoute: '/approvalTerms',
      isDisplayBackButton: true,
    };
  },
  computed: {
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t(
          '$vuetify.FECU58利用規約プライバシーポリシー同意画面.利用規約プライバシーポリシー'
        ), // "利用規約/プライバシーポリシー",
        hintText: vm.$vuetify.lang.t(
          '$vuetify.メッセージ一覧.FECU58利用規約プライバシーポリシー同意画面.C0001'
        ),
      };
    },
  },
  beforeMount() {
    if (this.$route.params['branch'] && this.$route.params['oneTimeUrlID']) {
      this.fromOneTimeUrl = true;
      this.urlRoute = this.$route.path;
      this.isDisplayBackButton = false;
    }
  },
  watch: {
    serviceCheck(newVal) {
      this.$store.state.serviceCheck = newVal;
    },
    privacyPolicyCheck(newVal) {
      this.$store.state.privacyPolicyCheck = newVal;
    },
  },
  mounted: function () {
    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);

    // 検証の際には以下URLで遷移可能
    // ~~/approvalTerms メインユーザーの本登録
    // ~~/approvalTerms/subUserRegistrerTemporarily/1 サブユーザーの本登録

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    this.serviceCheck = this.$store.state.serviceCheck;
    this.isTermsDisabled = !this.$store.state.serviceCheck;
    this.privacyPolicyCheck = this.$store.state.privacyPolicyCheck;
    this.isPrivacyPolicyDisabled = !this.$store.state.privacyPolicyCheck;

    // 外部html埋め込み
    this.loadHtml(this.$vuetify.lang.current);
  },
  /** @type {Methods} */
  methods: {
    /**
     * 次へボタン押下時処理
     * ユーザー登録画面へ遷移
     */
    goNext: function () {
      if (this.$route.params.branch) {
        // サブユーザーの場合
        if (this.$route.params.branch.indexOf('subUserRegistrerTemporarilyDistrict') != -1) {
          // 対象地区
          this.$router.replace({
            path:
              '/userRegistration' +
              '/subUserRegistrerDistrict' +
              '/' +
              this.$route.params.oneTimeUrlID,
          });
        } else {
          // カメラ
          this.$router.replace({
            path:
              '/userRegistration' +
              '/subUserRegistrerCamera' +
              '/' +
              this.$route.params.oneTimeUrlID,
          });
        }
      } else {
        // メインユーザーの場合
        this.$router.push('mainUserTempRegistration');
      }
    },
    /**
     * 外部html埋め込み処理
     * @param {*} lang 言語
     */
    loadHtml(lang) {
      var serviceAgreementHtmlPath = '';
      if (process.env.NODE_ENV === 'local') {
        serviceAgreementHtmlPath =
          lang === 'ja'
            ? process.env.VUE_APP_HS_STATIC_DOMAIN + 'hs-static/service-agreement-jpn.html'
            : process.env.VUE_APP_HS_STATIC_DOMAIN + 'hs-static/service-agreement-eng.html';
      } else {
        serviceAgreementHtmlPath =
          lang === 'ja'
            ? window.location.origin + '/hs-static/service-agreement-jpn.html'
            : window.location.origin + '/hs-static/service-agreement-eng.html';
      }

      var privacyPolicyHtmlPath = '';
      if (process.env.NODE_ENV === 'local') {
        privacyPolicyHtmlPath =
          lang === 'ja'
            ? process.env.VUE_APP_HS_STATIC_DOMAIN + 'hs-static/privacy-policy-jpn.html'
            : process.env.VUE_APP_HS_STATIC_DOMAIN + 'hs-static/privacy-policy-eng.html';
      } else {
        privacyPolicyHtmlPath =
          lang === 'ja'
            ? window.location.origin + '/hs-static/privacy-policy-jpn.html'
            : window.location.origin + '/hs-static/privacy-policy-eng.html';
      }

      fetch(serviceAgreementHtmlPath).then((res) => {
        res.text().then((html) => {
          this.termsMessage = html;
        });
      });
      fetch(privacyPolicyHtmlPath).then((res) => {
        res.text().then((html) => {
          this.privacyPolicyMessage = html;
        });
      });
    },
    /**
     * 利用規約を読むボタン押下時処理
     * 利用規約ダイアログを表示
     */
    onClickTerms() {
      this.loadHtml(this.$vuetify.lang.current);
    },
    /**
     * プライバシーポリシーを読むボタン押下時処理
     * プライバシーポリシーダイアログを表示
     */
    onClickPrivacyPolicy() {
      this.loadHtml(this.$vuetify.lang.current);
    },
    /**
     * 利用規約ダイアログを一番下までスクロールしたか判定
     * @param {*} e イベント
     */
    onScrollTerms(e) {
      const clientHeight = e.target.clientHeight;
      const scrollHeight = e.target.scrollHeight;
      const scrollTop = e.target.scrollTop;

      // 一番下まで行ったかの判定
      if (scrollHeight - (clientHeight + scrollTop) <= 25) {
        this.isTermsDisabled = false;
      }
    },
    /**
     * プライバシーポリシーダイアログを一番下までスクロールしたか判定
     * @param {*} e イベント
     */
    onScrollPrivacyPolicy(e) {
      const clientHeight = e.target.clientHeight;
      const scrollHeight = e.target.scrollHeight;
      const scrollTop = e.target.scrollTop;

      // 一番下まで行ったかの判定
      if (scrollHeight - (clientHeight + scrollTop) <= 25) {
        this.isPrivacyPolicyDisabled = false;
      }
    },
  },
  updated() {
    const termsDom = document.getElementById('terms-target');
    if (termsDom) {
      this.$nextTick(() => {
        if (termsDom.clientHeight == termsDom.scrollHeight) {
          this.isTermsDisabled = false;
        }
      });
    }

    const privacyPolicyDom = document.getElementById('privacyPolicy-target');
    if (privacyPolicyDom) {
      this.$nextTick(() => {
        if (privacyPolicyDom.clientHeight == privacyPolicyDom.scrollHeight) {
          this.isPrivacyPolicyDisabled = false;
        }
      });
    }
  },
  changeLang(lang) {
    this.loadHtml(lang);
  },
};
